import { Record } from 'immutable';

import PURCHASE_METHODS_V25 from 'commons-vehicle/PurchaseMethodsV25/constants/purchaseMethodsV25.js';

const PaymentOptionsMetadataRecord = Record({
    isAvailable: false,
    purchaseMethod: PURCHASE_METHODS_V25.FINANCE,
    financePlan: '',
    terms: [0],
    kmPerYearPlans: [0],
    paymentFrequencies: [0],
});

class PaymentOptionsMetadata extends PaymentOptionsMetadataRecord {}

export default PaymentOptionsMetadata;
